"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByProductData_1 = __importDefault(require("./SalesByProductData"));
class SalesByProductEdge {
    constructor({ cursor, node }) {
        this.toJSON = () => ({
            cursor: this.cursor,
            node: this.node,
        });
        this.cursor = cursor;
        this.node = node;
    }
}
SalesByProductEdge.fromJSON = (json) => {
    const { cursor, node } = Object.assign({}, json);
    if (typeof cursor !== 'string')
        throw new Error('.cursor must be a string');
    const _node = SalesByProductData_1.default.fromJSON(node);
    return new SalesByProductEdge({
        cursor,
        node: _node,
    });
};
exports.default = SalesByProductEdge;
